import { ReactElement, useState } from 'react'
import type { ProductReviews } from '@pylot-data/pylotschema'
import s from './ReviewsMobile.module.scss'
import ReviewRatings from './ReviewRatings/ReviewRatings'
import ReviewComments from './ReviewComments/ReviewComments'
import dynamic from 'next/dynamic'
import { Button } from '@lib/casaideas-components/pylot-ui'

const Modal = dynamic(() => import('@corratech/pylot-ui/src/Modal'))

type ReviewsMobileProps = {
    reviews: ProductReviews
    ratingSummary: number
    reviewCount: number
    sku: string
}
const COMMENTS_TITLE = 'COMENTARIOS'
const LOADMORE_TITLE = 'CARGAR MÁS COMENTARIOS'
/** Debe coincidir con MAX_PER_PAGE de ReviewComments cuando simplifiedComments=true */
const SIMPLIFIED_COMMENTS_PER_PAGE = 3

const ReviewsMobile: React.FC<ReviewsMobileProps> = ({
    reviews,
    ratingSummary,
    reviewCount,
    sku
}: ReviewsMobileProps): ReactElement | null => {
    const [displayReviewModal, setDisplayReviewModal] = useState(false)
    const commentCount = reviews?.items?.length ?? 0
    const shouldShowLoadMore = commentCount > SIMPLIFIED_COMMENTS_PER_PAGE

    const reviewModal = displayReviewModal ? (
        <Modal
            onClose={() => setDisplayReviewModal(false)}
            open={displayReviewModal}
            className={s['reviews-modal']}
            closeOnOverlayClick
        >
            <div className={s['review-modal-content']}>
                <p className={s['review-modal-heading']}>{COMMENTS_TITLE}</p>
                <ReviewRatings
                    reviews={reviews}
                    ratingSummary={ratingSummary}
                    reviewCount={reviewCount}
                />
                <ReviewComments reviews={reviews} sku={sku} />
            </div>
        </Modal>
    ) : null

    return (
        <>
            <div className={s['review-layout-mobile']}>
                <ReviewComments
                    reviews={reviews}
                    simplifiedComments
                    sku={sku}
                    ratingSummary={ratingSummary}
                />
                {shouldShowLoadMore && (
                    <Button
                        onClick={() => {
                            setDisplayReviewModal(true)
                        }}
                        className={s['review-loadmore']}
                    >
                        {LOADMORE_TITLE}
                    </Button>
                )}
            </div>
            {reviewModal}
        </>
    )
}

export default ReviewsMobile
